<template>
	<div class="allchain project-approval-page">
        <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-s-order"></i>
        <h2>上市公司投资项目库</h2>
      </div>
    </div>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value;ajaxsearchcompany(1)" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
                        <span class="title" @click="routerself('/investStatistics?navValue='+ list.value)" v-for="(list) in navList2" :key="'navlist2'+list.value">{{list.label}}</span>
                    </div>
                    <filterCom class="mt-3" v-show="navValue == 1" @search="searchList"></filterCom>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="pb-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table" v-loading="loading">
							<tr>
								<th>序号</th>
                                <th>公司名称</th>
								<th>项目名称</th>
                                <th>投资来源地</th>
                                <th>行业</th>
                                <th>投资地点</th>
								<th>投资金额（万）</th>
                                <th>日期</th>
                                <!-- <th>操作</th> -->
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.investArea}}</td>
                                <td class="title" @click="handlerLinkLocal('/investDetail?id='+item.id+'&pageType='+navValue)">{{item.title}}</td>
                                <td>{{item.sourceArea}}</td>
                                <td>{{item.industry}}</td>
                                <td>{{item.investArea}}</td>
                                <td>{{item.money}}</td>
                                <td style="width: 100px;">{{item.time}}</td>
                                 <!-- <td v-if="item.pushStatus == 0" class="collectfont1" :class="item.thread?'redfont':''" style="width: 100px;">
                                    <span @click="landThreadToggle(item,'invest')">{{item.thread == 0 ? '加入' : '移除'}}线索管理</span>
                                </td>
                                <td v-else style="width: 100px;">已推送</td> -->
                            </tr>
                    </table>
					</div>
					<!-- 分页 -->
                <div class="pagination-wrapper oh w95mg py-3" v-if="totalPage > 1">
                    <el-pagination class="fr" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="page" :page-sizes="[20]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total" background />
                </div>
				</div>

			</div>
		</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import filterCom from "./inc/filterCom.vue";
export default {
	name: 'landSearch',
    components: {
        filterCom
    },
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "报告库",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			yj_itemcode: "E02",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 20, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
            enterpristlist: [],
            navList: [
                {value:1,label:'投资项目检索'},
                // {value:3,label:'投资项目线索管理'},
            ],
            navList2: [
                {value:1,label:'项目行业分布'},
                {value:2,label:'项目区域分布'},
                {value:3,label:'企业统计分析'},
            ],
            navValue: 1,
            loading: false,
		}
	},
	created() {},
	mounted() {
        this.navValue = this.$route.query.navValue ? this.$route.query.navValue : 1; 
        this.ajaxsearchcompany(1);
    },
	methods: {
        searchList(filterData) { 
             //处理一下filterData里面为‘’和0的数据
            for(let key in filterData){
                if(filterData[key] == '' || filterData[key] == 0){
                    delete filterData[key];
                }
            }
            this.searchData = filterData;
            this.ajaxsearchcompany(1);
        },
        ajaxsearchcompany(pages) { 
            this.page = pages ? pages : 1;
            this.loading = true;
            let params = {
                page: this.page,
                pageSize: this.pageSize,
                ...this.searchData,
                 thread:this.navValue == 1 ? '0' : '1',
            };
            this.$axios.get(this.$api.metall.invest.List(), { params: params }).then((res) => {
               if (res.success) { 
                this.enterpristlist = res.list;
                this.totalPage = res.totalPage;
                this.total = res.totalRecord;
                this.pageSize = res.pageSize;
                this.loading = false;
               } else {
                   this.$message.error(res.message);
               }
           })
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.ajaxsearchcompany()
        },

        handleCurrentChange(val) {
            this.page = val
            this.ajaxsearchcompany(val);
        }
    },
}
</script>

<style lang="scss" >

.collectfont1{
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;
    &:hover{
        color: #f19d00;
    }
}
.land_table{
    margin:  0 auto;
    border: 1px solid #f2f2f2; 
    background: #fff;
    width: 95%;
    .title{
        cursor: pointer;
        color: #305ea3;
        &:hover{
            color: #f19d00;
            text-decoration: underline;
        } 
    }
    th{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    height: 54px;
    line-height: 54px;
    background: #f2f8fe;
    white-space: nowrap;
    padding: 0 10px;
    border-right: 1px solid #dcdcdc;
    }
    tr{
        height: 40px;
        border-bottom: 1px solid #dcdcdc;
        td{
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
        }
    }
}
</style>